import Boks from './Boks'

const Mma = () => <Boks calculatorType='Mma' />

export default Mma
